// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { Form, FormItem, IFormInstance, ModalSize } from '@/components';
import { StyledButton, StyledText, StyledTitle } from '../Styled';

// Helpers
import { AuthFieldsNames, TForgotPasswordFormValues } from '../../helpers/types';
import { StyledInput, StyledModal } from './ForgotPasswordModalStyles';
import { useForgotPasswordRules } from '../../hooks/useValidationRules';

interface IForgotPasswordModal {
  formInstance: IFormInstance;
  handleSubmit: (values: TForgotPasswordFormValues) => void;
  onClose: () => void;
  isLoading: boolean;
  isOpened: boolean;
}

const ForgotPasswordModal = ({ formInstance, handleSubmit, isLoading, isOpened, onClose }: IForgotPasswordModal) => {
  const { t } = useTranslation(['auth', 'common']);
  const rules = useForgotPasswordRules();

  return (
    <StyledModal visible={isOpened} onClose={onClose} onCancel={onClose} size={ModalSize.LARGE}>
      <StyledTitle>{t('auth_forgot_password_restore')}</StyledTitle>
      <StyledText>{t('auth_forgot_password_restore_message')}</StyledText>

      <Form onFinish={handleSubmit} form={formInstance} noValidate>
        <FormItem name={AuthFieldsNames.EMAIL} label={t('auth_email')} rules={rules[AuthFieldsNames.EMAIL]}>
          <StyledInput placeholder={t('common_placeholder_input', { ns: 'common' })} type="email" />
        </FormItem>

        <StyledButton type="primary" htmlType="submit" loading={isLoading}>
          {t('auth_forgot_password_send_letter')}
        </StyledButton>
      </Form>
    </StyledModal>
  );
};

export default ForgotPasswordModal;
